// src/components/Modal.js
import React from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import close from "../icons/close.svg";
import moment from "moment";
import "./Modal.css";

const Modal2 = ({ isOpen, onClose, modalData }) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="modal fade show"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.4)" }}
    >
      <div id="modalDialog" className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modalbody">
            <button
              className="closebtnModal"
              type="button"
              onClick={onClose}
              aria-label="Close"
            >
              <img src={close} alt="close" />
            </button>
            <div className="modalImg">
              {/* <img src={modalData.imgUrl} alt="drawing topic here" /> */}
              {/* Conditionally render video or image */}
              {modalData.videoUrl ? (
                <video src={modalData.videoUrl} autoPlay controls>
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img src={modalData.imgUrl} alt="drawing topic here" />
              )}
            </div>
            <div className="modalDetails">
              <div className="topDetails">
                <h4>{modalData.projectTopic}</h4>
                <div className="modal-grid">
                  <div className="heading">Category</div>
                  <div className="colon">:</div>
                  <div className="modal-data">{modalData.projectCategory}</div>

                  <div className="heading">Type</div>
                  <div className="colon">:</div>
                  <div className="modal-data">{modalData.projectType}</div>

                  <div className="heading">Date</div>
                  <div className="colon">:</div>
                  <div className="modal-data">
                    {moment(modalData.projectTimePeriod).format("MMMM Do YYYY")}
                  </div>

                  <div className="heading">Technologies</div>
                  <div className="colon">:</div>
                  <div className="modal-data">{modalData.projectTechnologies}</div>

                  <div className="heading">Description</div>
                  <div className="colon">:</div>
                  <div className="modal-data">{modalData.projectDescription}</div>
                </div>

                {/* <table className="ModalTable">
                  <tbody>
                    <tr>
                      <th>Category</th>
                      <td>: {modalData.projectCategory}</td>
                    </tr>
                    <tr>
                      <th>Type</th>
                      <td>: {modalData.projectType}</td>
                    </tr>
                    <tr>
                      <th>Date</th>
                      <td>
                        :
                        {moment(modalData.projectTimePeriod).format(
                          "MMMM Do YYYY"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>Technologies</th>
                      <td>: {modalData.projectTechnologies}</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td>: {modalData.projectDescription}</td>
                    </tr>
                  </tbody>
                </table> */}
              </div>
              <div className="bottomDetails">

                {/* Conditionally render preview button or without button */}
                {modalData.previewUrl ? (
                  <Link to={modalData.previewUrl} target="_blank">
                    <button className="PreviewBtnModal" type="button">
                      Preview
                    </button>
                  </Link>
                ) : null}
                <p>
                  <span>
                    Created At:{" "}
                    {moment(modalData.createdAt).format(
                      "MMMM Do YYYY | h:mm a"
                    )}
                  </span>
                </p>
                <p>
                  <span>
                    Updated At:{" "}
                    {moment(modalData.updatedAt).format(
                      "MMMM Do YYYY | h:mm a"
                    )}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("modal-root") // Create this div in your public/index.html file
  );
};

export default Modal2;
